export const translations = {
  vi: {
    home_title: "Lớp học chán òm? Kéo mọi người vào cuộc.",
    home_subtitle: "Biến câu hỏi thành game realtime để học sinh cùng trả lời, thi đua và vui vẻ hơn — ngay trên điện thoại.",
    home_image_alt: "Lớp học hào hứng tham gia quiz Heart150",
    home_eyebrow: "Quiz realtime cho lớp học",
    home_no_install: "Không cần cài app",
    home_try_first: "Có chế độ chơi thử",
    home_demo_question: "Cả lớp đã sẵn sàng chưa?",
    home_final_kicker: "Bắt đầu nhẹ nhàng",
    support_eyebrow: "Hỗ trợ Heart150",
    support_title: "Support",
    support_intro: "Cần trợ giúp hoặc muốn trao đổi với cộng đồng Heart150? Tham gia nhóm hỗ trợ của chúng tôi.",
    support_community: "Cộng đồng hỗ trợ",
    support_zalo_title: "Nhóm Zalo Heart150",
    support_zalo_help: "Đặt câu hỏi, chia sẻ phản hồi và nhận hỗ trợ trực tiếp từ cộng đồng Heart150 trên Zalo.",
    support_join_zalo: "Tham gia nhóm Zalo",
    start_free: "Bắt đầu miễn phí",
    how_it_works: "Cách hoạt động",
    home_pain_kicker: "Chuyện thường ngày",
    home_pain_title: "Một người nói, cả lớp im lặng",
    home_pain: "Học sinh mất tập trung, ngại trả lời và chỉ chờ buổi học kết thúc.",
    home_solution_kicker: "Đổi không khí",
    home_solution_title: "Cho cả lớp cùng chơi",
    home_solution: "Mỗi câu hỏi trở thành một vòng thi ngắn. Ai cũng có thể tham gia, bảng xếp hạng cập nhật ngay và không khí vui lên rõ rệt.",
    how_title: "Bắt đầu trong vài phút",
    how_step_1: "Tạo quiz",
    how_step_1_desc: "Tự viết câu hỏi hoặc nhờ AI tạo bản nháp.",
    how_step_2: "Quét mã để vào",
    how_step_2_desc: "Học sinh dùng điện thoại, không cần cài ứng dụng.",
    how_step_3: "Cùng chơi realtime",
    how_step_3_desc: "Trả lời, tính điểm và xem bảng xếp hạng ngay.",
    cta_final_help: "Chơi thử trước. Khi cần mới tổ chức thật — không phải trả nhiều tiền cho một công cụ ít dùng.",
    problem_title: "Hầu hết các sự kiện có cảm giác như Heart72",
    problem_1: "Khán giả thụ động, mệt mỏi",
    problem_2: "Năng lượng phòng rất thấp",
    problem_3: "Mọi người liên tục bấm điện thoại",
    problem_4: "Các buổi hội thảo nhanh chóng bị lãng quên",
    transform_title: "Tạo nên khoảnh khắc Heart150",
    transform_72: "Bình thường",
    transform_100: "Tập trung",
    transform_120: "Cạnh tranh kịch tính",
    transform_150: "Cả phòng vỡ òa!",
    features_title: "Tính năng nổi bật",
    feature_1: "Tạo game trong vài phút",
    feature_2: "Bảng xếp hạng thời gian thực",
    feature_3: "Thay đổi thứ hạng cực nhanh",
    feature_4: "Bục vinh quang rực rỡ",
    feature_5: "Tham gia nhanh trên điện thoại",
    feature_6: "Đăng nhập Google thuận tiện",
    cta_final: "Buổi học tiếp theo, vui hơn một chút nhé?",
    demo_title: "Trực quan hóa Trải nghiệm Realtime",
    demo_subtitle: "Giao diện Host trực quan hiển thị dữ liệu bảng xếp hạng bùng nổ kết nối liền mạch với các thiết bị di động của người chơi trong chưa đầy 100ms.",
    login_title: "Đăng nhập",
    login_btn: "Tiếp tục với Google",
    dashboard_title: "Bảng điều khiển",
    create_game: "Tạo game mới",
    recent_games: "Trò chơi gần đây",
    no_games: "Bạn chưa có game nào. Hãy tạo một cái ngay!",
    launch: "Bắt đầu chơi",
    edit: "Sửa",
    delete: "Xóa",
    pin_quiz: "Ghim quiz",
    unpin_quiz: "Bỏ ghim quiz",
    quiz_pinned: "Đã ghim quiz lên đầu",
    quiz_unpinned: "Đã bỏ ghim quiz",
    questions: "câu hỏi",
    lobby_title: "Phòng chờ phiên đấu",
    lobby_pin: "MÃ SỐ PHÒNG (PIN)",
    lobby_qr: "Quét để vào phòng",
    lobby_count: "Người tham gia",
    lobby_start: "Bắt đầu chơi",
    lobby_waiting: "Đang chờ người chơi tham gia...",
    join_title: "Tham gia game",
    join_pin: "Mã số PIN",
    join_nickname: "Biệt danh (Nickname)",
    join_btn: "Vào phòng chơi",
    play_waiting_question: "Chờ câu hỏi tiếp theo...",
    play_correct: "Chính xác!",
    play_incorrect: "Sai rồi!",
    play_streak: "Chuỗi liên tục",
    play_rank: "Hạng hiện tại",
    play_points: "Điểm",
    present_answers: "câu trả lời",
    present_next: "Tiếp tục",
    leaderboard_title: "Bảng xếp hạng",
    podium_title: "Bục vinh quang",
    podium_winner: "Chúc mừng nhà vô địch!",
    podium_screenshot: "Chụp ảnh lưu niệm",
    podium_share: "Chia sẻ kết quả",
    report_title: "Báo cáo phiên đấu",
    report_summary: "Tóm tắt trận đấu",
    report_completion: "Tỷ lệ hoàn thành",
    report_avg_score: "Điểm trung bình",
    report_toughest: "Câu hỏi khó nhất",
    back_to_dashboard: "Quay lại Bảng điều khiển",
    settings: "Cài đặt",
    logout: "Đăng xuất",
    logout_success: "Đã đăng xuất",
    dashboard_description: "Quản lý trò chơi và theo dõi hiệu quả của từng phiên chơi.",
    host_workspace: "Không gian của Host",
    dashboard_overview: "Tổng quan Dashboard",
    completed_sessions: "Phiên đã hoàn thành",
    quiz_library: "Thư viện quiz",
    quiz_library_help: "Chọn một quiz để xem chi tiết và quản lý.",
    session_history_help: "Các phiên chơi thật gần nhất.",
    pinned: "Đã ghim",
    session_history: "Lịch sử phiên đấu",
    no_sessions: "Chưa có phiên chơi nào hoàn thành.",
    no_description: "Không có mô tả",
    deleted_game: "Trò chơi đã xóa",
    view_summary: "Xem tổng kết",
    players: "Người chơi",
    completed: "Hoàn thành",
    leaderboard_people: "người",
    no_data: "Chưa có dữ liệu.",
    review_question: "Câu hỏi cần xem lại",
    view_details: "Xem chi tiết",
    toughest_help: "Đây là câu hỏi có tỷ lệ trả lời sai cao nhất trong phiên.",
    account_settings: "Cài đặt tài khoản",
    account_settings_help: "Thông tin tài khoản Google đang đăng nhập.",
    language_title: "Ngôn ngữ",
    language_help: "Chọn ngôn ngữ hiển thị cho giao diện Heart150.",
    create_game_title: "Tạo trò chơi mới",
    edit_game_title: "Chỉnh sửa trò chơi",
    cancel: "Hủy",
    save_game: "Lưu game",
    basic_info: "Thông tin cơ bản",
    editing_mode: "Chỉnh sửa",
    editing_mode_off_help: "Mở từng phần và bật Chỉnh sửa khi cần thay đổi nội dung.",
    editing_mode_on_help: "Chế độ chỉnh sửa — click vào từng trường để mở khóa và chỉnh sửa.",
    choose_cover: "Chọn ảnh bìa",
    cover_sample: "Mẫu",
    untitled_quiz: "Quiz chưa đặt tên",
    game_name: "Tên trò chơi",
    game_name_placeholder: "Nhập tên trò chơi...",
    short_description: "Mô tả ngắn",
    description_placeholder: "Mô tả giúp người chơi hiểu nội dung...",
    default_time: "Thời gian trả lời mặc định (giây)",
    cover_url: "Đường dẫn ảnh bìa",
    require_google_login: "Yêu cầu người chơi đăng nhập bằng Google",
    optional: "Tùy chọn",
    ai_generate: "Tạo câu hỏi bằng AI",
    ai_topic: "Chủ đề hoặc nội dung bài học",
    ai_topic_placeholder: "Ví dụ: Hệ Mặt Trời dành cho học sinh lớp 6",
    question_count: "Số câu hỏi",
    difficulty: "Độ khó",
    easy: "Dễ",
    medium: "Trung bình",
    hard: "Khó",
    generate_draft: "Tạo bản nháp",
    generating: "Đang tạo...",
    ai_draft_help: "AI tạo bản nháp. Host cần xem lại đáp án trước khi lưu và khởi chạy.",
    question_list: "Danh sách câu hỏi",
    question: "Câu hỏi",
    add_question: "Thêm câu hỏi",
    delete_question: "Xóa câu hỏi",
    question_content: "Nội dung câu hỏi",
    question_placeholder: "Nhập nội dung câu hỏi...",
    answer_options: "Các lựa chọn đáp án (chọn một đáp án đúng)",
    explanation: "Giải thích đáp án (không bắt buộc)",
    explanation_placeholder: "Giải thích vì sao đáp án này đúng...",
    answer_placeholder: "Nhập đáp án...",
    loading_game: "Đang tải thông tin trò chơi...",
    loading_report: "Đang tính toán báo cáo...",
    feature_desc_1: "Tạo bộ câu hỏi nhanh chóng với giao diện trực quan.",
    feature_desc_2: "Bảng xếp hạng cập nhật thời gian thực sau mỗi câu trả lời.",
    feature_desc_3: "Theo dõi thay đổi thứ hạng tức thì trong suốt phiên chơi.",
    feature_desc_4: "Vinh danh người chiến thắng trên bục xếp hạng.",
    feature_desc_5: "Người chơi quét QR, nhập biệt danh và tham gia ngay.",
    feature_desc_6: "Host đăng nhập an toàn và thuận tiện bằng Google.",
    sessions_run: "Phiên chơi đã chạy",
    participants: "Người tham gia",
    heart_moments: "Khoảnh khắc nhịp tim 150bpm",
    lobby_loading: "Đang khởi tạo phòng chờ...",
    everyone_ready: "Mọi người đã sẵn sàng!",
    or_visit: "Hoặc truy cập:",
    play_loading: "Đang vào phòng thi đấu...",
    joined_lobby: "Bạn đã vào phòng chờ!",
    nickname: "Biệt danh",
    answer_recorded: "Đã ghi nhận câu trả lời!",
    network_error: "Kết nối chưa ổn định. Hệ thống đang tự đồng bộ lại.",
    waiting_others: "Đang chờ những người chơi khác hoàn thành câu hỏi...",
    send_reaction: "Gửi biểu cảm",
    correct_streak: "câu trả lời đúng liên tiếp",
    keep_trying: "Đừng nản lòng! Hãy cố gắng hơn ở câu sau.",
    total_score: "Tổng điểm",
    status: "Trạng thái",
    see_host_screen: "Xem màn hình Host",
    game_finished: "Trò chơi kết thúc!",
    podium_hint: "Hãy nhìn lên màn hình chính để xem bạn có lọt vào Top 3 không nhé!",
    exit_game: "Thoát chơi",
    brand_title: "Brand của Host",
    brand_help: "Tên công ty và tagline sẽ xuất hiện trong các phiên quiz của bạn.",
    brand_default_name: "Brand của bạn",
    brand_default_tagline: "Thêm tên công ty và tagline để xuất hiện trong các phiên quiz.",
    setup_brand: "Thiết lập Brand",
    edit_brand: "Chỉnh sửa Brand",
    brand_name: "Tên công ty",
    brand_name_placeholder: "Ví dụ: Conan Education",
    brand_tagline: "Tagline",
    brand_tagline_placeholder: "Ví dụ: Học tập đầy hứng khởi",
    save_brand: "Lưu Brand",
    brand_first_lock: "Sau lần lưu đầu tiên, Brand có thể đổi lại sau 1 giờ.",
    brand_weekly_lock: "Sau lần thay đổi đầu tiên, Brand chỉ có thể cập nhật mỗi 7 ngày.",
    brand_locked_until: "Có thể chỉnh sửa lại vào",
    brand_saved: "Đã lưu Brand",
    session_not_found: "Phiên chơi không tồn tại.",
    session_started: "Phiên chơi đã bắt đầu.",
    session_not_started: "Phiên chơi chưa bắt đầu.",
    results_not_revealed: "Kết quả chưa được công bố.",
    session_not_finished: "Phiên chơi chưa kết thúc.",
    join_intro: "Nhập mã PIN để tham gia phiên quiz realtime.",
    invalid_pin: "Mã PIN không chính xác hoặc phiên chơi đã kết thúc.",
    player_auth_required: "Phòng này yêu cầu xác thực người chơi",
    sign_in_google: "Đăng nhập với Google",
    nickname_placeholder: "Ví dụ: Minh, Anna...",
    welcome_lobby: "Đã vào phòng chờ",
    player_joined: "đã tham gia",
    preparing_present: "Đang chuẩn bị câu hỏi trình chiếu...",
    seconds: "Giây",
    answered: "Đã trả lời",
    answer_revealed: "Đã công bố đáp án",
    host_explanation: "Giải thích từ Host",
    loading_leaderboard: "Đang tải bảng xếp hạng...",
    no_result: "Chưa có",
    score_after_question: "Bảng điểm sau câu hỏi",
    view_podium: "Xem Bục Vinh Quang",
    next_question: "Câu hỏi tiếp theo",
    preparing_podium: "Đang chuẩn bị bục vinh quang...",
    view_report: "Xem báo cáo",
    podium_energy: "Nhịp tim phòng đấu đã đạt mức 150bpm!",
    back_host_dashboard: "Quay lại bảng điều khiển Host",
    screenshot_saved: "Đã lưu ảnh chụp màn hình.",
    share_copied: "Đã sao chép liên kết chia sẻ.",
    add_option: "Thêm lựa chọn",
    delete_option: "Xóa đáp án",
    max_questions: "Đã đạt giới hạn 15 câu hỏi cho mỗi quiz.",
    quiz_length_recommendation: "Nên dừng lại giải thích sau mỗi câu. Với khoảng 3 phút/câu, một quiz không nên quá 10 câu.",
    enter_ai_topic: "Hãy nhập chủ đề cần tạo câu hỏi.",
    game_saved: "Đã lưu trò chơi.",
    try_game: "Chơi thử",
    play_live: "Chơi thật",
    hello_host: "Chào host,",
    view_quiz_details: "Xem chi tiết quiz",
    session_actions_kicker: "Phiên chơi",
    start_session: "Bắt đầu phiên chơi",
    session_actions_help: "Chọn chơi thử để kiểm tra quiz hoặc chơi thật khi đã sẵn sàng.",
    preview_mode: "Chế độ chơi thử",
    preview_ready: "Có thể bắt đầu ngay hoặc dùng điện thoại tham gia qua QR.",
    start_preview: "Bắt đầu chơi thử",
    live_minimum_help: "Chơi thật cần ít nhất 5 người chơi.",
    need_more_players: "Cần thêm {count} người để bắt đầu chơi thật.",
    preview_created: "Đã tạo phòng chơi thử.",
    live_created: "Đã tạo phòng chơi thật.",
  },
  en: {
    home_title: "Boring class? Get everyone into the game.",
    home_subtitle: "Turn questions into a realtime game where students answer, compete, and have fun — right on their phones.",
    home_image_alt: "An engaged class playing a Heart150 quiz",
    home_eyebrow: "Realtime quizzes for classrooms",
    home_no_install: "No app installation",
    home_try_first: "Preview mode included",
    home_demo_question: "Is everyone ready?",
    home_final_kicker: "Start small",
    support_eyebrow: "Heart150 support",
    support_title: "Support",
    support_intro: "Need help or want to connect with the Heart150 community? Join our support group.",
    support_community: "Support community",
    support_zalo_title: "Heart150 Zalo Group",
    support_zalo_help: "Ask questions, share feedback, and get direct support from the Heart150 community on Zalo.",
    support_join_zalo: "Join the Zalo Group",
    start_free: "Start Free",
    how_it_works: "How it works",
    home_pain_kicker: "The usual problem",
    home_pain_title: "One person talks. The whole class stays quiet.",
    home_pain: "Students lose focus, hesitate to answer, and wait for class to end.",
    home_solution_kicker: "Change the energy",
    home_solution_title: "Let the whole class play",
    home_solution: "Every question becomes a quick round. Everyone can join, the leaderboard updates instantly, and the room comes alive.",
    how_title: "Start in minutes",
    how_step_1: "Create a quiz",
    how_step_1_desc: "Write your own questions or ask AI for a draft.",
    how_step_2: "Scan to join",
    how_step_2_desc: "Students use their phones. No app installation needed.",
    how_step_3: "Play in realtime",
    how_step_3_desc: "Answer, score points, and see the live leaderboard.",
    cta_final_help: "Try it first. Host a live game only when needed — without overpaying for a tool you rarely use.",
    problem_title: "Most Events Feel Like Heart72",
    problem_1: "Passive audiences, low energy",
    problem_2: "Low energy rooms",
    problem_3: "People checking phones",
    problem_4: "Forgettable workshops",
    transform_title: "Create Heart150 Moments",
    transform_72: "Normal room",
    transform_100: "Attention rises",
    transform_120: "Competition starts",
    transform_150: "The room explodes!",
    features_title: "Key Features",
    feature_1: "Create games in minutes",
    feature_2: "Live leaderboard",
    feature_3: "Real-time ranking changes",
    feature_4: "Winner podium with confetti",
    feature_5: "Mobile participation",
    feature_6: "Google login",
    cta_final: "Make the next class a little more fun.",
    demo_title: "Visualize the Real-time Experience",
    demo_subtitle: "The intuitive Host interface displays explosive ranking telemetry, connecting seamlessly with players' mobile devices in under 100ms.",
    login_title: "Sign In",
    login_btn: "Continue with Google",
    dashboard_title: "Dashboard",
    create_game: "Create New Game",
    recent_games: "Recent Games",
    no_games: "No games found. Create one to get started!",
    launch: "Launch",
    edit: "Edit",
    delete: "Delete",
    pin_quiz: "Pin quiz",
    unpin_quiz: "Unpin quiz",
    quiz_pinned: "Quiz pinned to the top",
    quiz_unpinned: "Quiz unpinned",
    questions: "questions",
    lobby_title: "Session Lobby",
    lobby_pin: "GAME PIN",
    lobby_qr: "Scan to Join",
    lobby_count: "Participants",
    lobby_start: "Start Game",
    lobby_waiting: "Waiting for players to join...",
    join_title: "Join Game",
    join_pin: "Game PIN",
    join_nickname: "Nickname",
    join_btn: "Join Game",
    play_waiting_question: "Waiting for next question...",
    play_correct: "Correct!",
    play_incorrect: "Incorrect!",
    play_streak: "Streak",
    play_rank: "Current Rank",
    play_points: "Points",
    present_answers: "answers",
    present_next: "Next",
    leaderboard_title: "Leaderboard",
    podium_title: "Winner Podium",
    podium_winner: "Congratulations to the Champions!",
    podium_screenshot: "Take Screenshot",
    podium_share: "Share Results",
    report_title: "Session Report",
    report_summary: "Session Summary",
    report_completion: "Completion Rate",
    report_avg_score: "Average Score",
    report_toughest: "Toughest Question",
    back_to_dashboard: "Back to Dashboard",
    settings: "Settings",
    logout: "Logout",
    logout_success: "Logged out successfully",
    dashboard_description: "Manage your games and review performance for every session.",
    host_workspace: "Host workspace",
    dashboard_overview: "Dashboard overview",
    completed_sessions: "Completed sessions",
    quiz_library: "Quiz library",
    quiz_library_help: "Choose a quiz to view its details and manage it.",
    session_history_help: "Your latest completed live sessions.",
    pinned: "Pinned",
    session_history: "Session History",
    no_sessions: "No completed sessions yet.",
    no_description: "No description",
    deleted_game: "Deleted game",
    view_summary: "View summary",
    players: "Players",
    completed: "Completed",
    leaderboard_people: "players",
    no_data: "No data yet.",
    review_question: "Question to review",
    view_details: "View details",
    toughest_help: "This question had the highest incorrect-answer rate in this session.",
    account_settings: "Account Settings",
    account_settings_help: "Details for the Google account currently signed in.",
    language_title: "Language",
    language_help: "Choose the display language for the Heart150 interface.",
    create_game_title: "Create New Game",
    edit_game_title: "Edit Game",
    cancel: "Cancel",
    save_game: "Save Game",
    basic_info: "Basic Information",
    editing_mode: "Edit",
    editing_mode_off_help: "Open a section and turn on Edit when you need to change its content.",
    editing_mode_on_help: "Editing mode — select an individual field to unlock and edit it.",
    choose_cover: "Choose a cover",
    cover_sample: "Sample",
    untitled_quiz: "Untitled quiz",
    game_name: "Game name",
    game_name_placeholder: "Enter a game name...",
    short_description: "Short description",
    description_placeholder: "Help players understand what this game covers...",
    default_time: "Default answer time (seconds)",
    cover_url: "Cover image URL",
    require_google_login: "Require players to sign in with Google",
    optional: "Optional",
    ai_generate: "Generate questions with AI",
    ai_topic: "Topic or lesson content",
    ai_topic_placeholder: "Example: The Solar System for grade 6 students",
    question_count: "Number of questions",
    difficulty: "Difficulty",
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",
    generate_draft: "Generate draft",
    generating: "Generating...",
    ai_draft_help: "AI creates a draft. The Host must review the answers before saving and launching.",
    question_list: "Questions",
    question: "Question",
    add_question: "Add question",
    delete_question: "Delete question",
    question_content: "Question text",
    question_placeholder: "Enter the question...",
    answer_options: "Answer options (select one correct answer)",
    explanation: "Answer explanation (optional)",
    explanation_placeholder: "Explain why this answer is correct...",
    answer_placeholder: "Enter an answer...",
    loading_game: "Loading game...",
    loading_report: "Preparing report...",
    feature_desc_1: "Create a complete quiz quickly with an intuitive editor.",
    feature_desc_2: "The leaderboard updates in real time after every answer.",
    feature_desc_3: "Follow instant ranking changes throughout the session.",
    feature_desc_4: "Celebrate winners on the final podium.",
    feature_desc_5: "Players scan a QR code, enter a nickname, and join instantly.",
    feature_desc_6: "Hosts sign in securely and conveniently with Google.",
    sessions_run: "Sessions run",
    participants: "Participants",
    heart_moments: "Heart150 moments",
    lobby_loading: "Preparing the lobby...",
    everyone_ready: "Everyone is ready!",
    or_visit: "Or visit:",
    play_loading: "Joining the game...",
    joined_lobby: "You joined the lobby!",
    nickname: "Nickname",
    answer_recorded: "Answer recorded!",
    network_error: "The connection is unstable. The game is resyncing automatically.",
    waiting_others: "Waiting for the other players to finish...",
    send_reaction: "Send a reaction",
    correct_streak: "correct answers in a row",
    keep_trying: "Keep going! Try again on the next question.",
    total_score: "Total score",
    status: "Status",
    see_host_screen: "See the Host screen",
    game_finished: "Game finished!",
    podium_hint: "Look at the main screen to see whether you made the Top 3!",
    exit_game: "Exit game",
    brand_title: "Host Brand",
    brand_help: "Your company name and tagline will appear throughout your quiz sessions.",
    brand_default_name: "Your brand",
    brand_default_tagline: "Add your company name and tagline for display in quiz sessions.",
    setup_brand: "Set up Brand",
    edit_brand: "Edit Brand",
    brand_name: "Company name",
    brand_name_placeholder: "Example: Conan Education",
    brand_tagline: "Tagline",
    brand_tagline_placeholder: "Example: Make learning exciting",
    save_brand: "Save Brand",
    brand_first_lock: "After the first save, the Brand can be changed again after one hour.",
    brand_weekly_lock: "After the first change, the Brand can only be updated every 7 days.",
    brand_locked_until: "Editable again at",
    brand_saved: "Brand saved",
    session_not_found: "Session not found.",
    session_started: "This session has already started.",
    session_not_started: "This session has not started yet.",
    results_not_revealed: "Results have not been revealed yet.",
    session_not_finished: "This session has not finished yet.",
    join_intro: "Enter a PIN to join a realtime quiz.",
    invalid_pin: "The PIN is invalid or the session has ended.",
    player_auth_required: "This room requires player authentication",
    sign_in_google: "Sign in with Google",
    nickname_placeholder: "Example: Minh, Anna...",
    welcome_lobby: "Joined the lobby",
    player_joined: "joined",
    preparing_present: "Preparing the question...",
    seconds: "Seconds",
    answered: "Answered",
    answer_revealed: "Answer revealed",
    host_explanation: "Host explanation",
    loading_leaderboard: "Loading leaderboard...",
    no_result: "None yet",
    score_after_question: "Scores after question",
    view_podium: "View Winner Podium",
    next_question: "Next question",
    preparing_podium: "Preparing the winner podium...",
    view_report: "View report",
    podium_energy: "The room reached Heart150 energy!",
    back_host_dashboard: "Back to Host Dashboard",
    screenshot_saved: "Screenshot saved.",
    share_copied: "Share link copied.",
    add_option: "Add option",
    delete_option: "Delete answer",
    max_questions: "The 15-question limit has been reached for this quiz.",
    quiz_length_recommendation: "Pause to explain after each question. At about 3 minutes per question, a quiz should stay within 10 questions.",
    enter_ai_topic: "Enter a topic for AI question generation.",
    game_saved: "Game saved.",
    try_game: "Try game",
    play_live: "Play live",
    hello_host: "Hello, host",
    view_quiz_details: "View quiz details",
    session_actions_kicker: "Game session",
    start_session: "Start a session",
    session_actions_help: "Preview the quiz first or start a live session when you are ready.",
    preview_mode: "Preview mode",
    preview_ready: "Start now or join from a phone using the QR code.",
    start_preview: "Start preview",
    live_minimum_help: "Live games require at least 5 players.",
    need_more_players: "{count} more players required to start live.",
    preview_created: "Preview room created.",
    live_created: "Live room created.",
  }
};

let currentLang = localStorage.getItem("h150_lang") || "vi";

export const i18n = {
  getLang() {
    return currentLang;
  },
  setLang(lang) {
    currentLang = lang;
    localStorage.setItem("h150_lang", lang);
    document.documentElement.lang = lang;
    window.dispatchEvent(new Event("languageChanged"));
  },
  t(key) {
    return translations[currentLang]?.[key] || translations["vi"]?.[key] || key;
  }
};
